import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function OrderReturnStatus(props) {
  const {
    orderStatus,
    orderStatusColor,
    testID = "",
    height = 20,
    width = 20,
    color = "",
  } = props;
  switch (orderStatus) {
    case "usersUnableToDeliver":
      return (
        <Svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          {...props}
          testID={testID}
        >
          <Circle cx={10} cy={10} r={8} fill="#FF2E00" />
          <Path
            d="M10.733 10l3.115-3.115a.518.518 0 10-.733-.733L10 9.267 6.885 6.152a.518.518 0 10-.733.733L9.267 10l-3.115 3.115a.518.518 0 10.733.733L10 10.733l3.115 3.115a.517.517 0 00.733 0 .518.518 0 000-.733L10.733 10z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.5}
          />
        </Svg>
      );

    case "usersDelivered":
      return (
        <Svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          {...props}
        >
          <Path
            d="M10 2c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zM7.832 13.432L4.96 10.56a.797.797 0 111.128-1.128L8.4 11.736l5.504-5.504a.797.797 0 111.128 1.128L8.96 13.432a.797.797 0 01-1.128 0z"
            fill={color ? "#fff" : "#27AE60"}
          />
        </Svg>
      );

    case "itemsNotReturned":
      return (
        <Svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          {...props}
          testID={testID}
        >
          <Circle cx={10} cy={10} r={8} fill="#FF2E00" />
          <Path
            d="M10.733 10l3.115-3.115a.518.518 0 10-.733-.733L10 9.267 6.885 6.152a.518.518 0 10-.733.733L9.267 10l-3.115 3.115a.518.518 0 10.733.733L10 10.733l3.115 3.115a.517.517 0 00.733 0 .518.518 0 000-.733L10.733 10z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.5}
          />
        </Svg>
      );

    case "itemsToBeReturned":
      return (
        <Svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            d="M10.3333 1.66644C5.73333 1.66644 2 5.39978 2 9.99978C2 14.5998 5.73333 18.3331 10.3333 18.3331C14.9333 18.3331 18.6667 14.5998 18.6667 9.99978C18.6667 5.39978 14.9333 1.66644 10.3333 1.66644Z"
            fill="black"
          />
          <Path
            d="M15 13.7885C14.9203 13.9599 14.8124 14.0266 14.6764 13.9909C14.5615 13.9623 14.5005 13.8837 14.4747 13.7694C14.0948 12.1243 13.0654 11.1315 11.4732 10.7077C11.1707 10.6267 10.8588 10.5934 10.5446 10.5743C10.4836 10.5696 10.4789 10.591 10.4789 10.641C10.4812 11.0886 10.4812 11.5362 10.4789 11.9862C10.4789 12.1838 10.3452 12.3052 10.167 12.279C10.1201 12.2719 10.0779 12.2481 10.0404 12.2195C8.74127 11.2743 7.43512 10.3291 6.13132 9.38631C6.07269 9.34345 6.03986 9.28393 6 9.22679C6 9.17917 6 9.13156 6 9.08394C6.01407 8.99347 6.068 8.93395 6.1407 8.88157C7.27332 8.06256 8.40594 7.24355 9.53622 6.42454C9.69567 6.30788 9.85513 6.1936 10.0146 6.07932C10.1154 6.00789 10.2233 5.96742 10.3429 6.03408C10.4578 6.10075 10.507 6.2055 10.5047 6.33883C10.5023 6.76262 10.5047 7.18641 10.5047 7.61258C10.5047 7.71019 10.4859 7.734 10.6172 7.75067C11.1824 7.82209 11.7217 7.98875 12.2306 8.24826C13.0701 8.67682 13.722 9.30774 14.1933 10.1291C14.4935 10.6553 14.6975 11.2196 14.8265 11.81C14.8992 12.1362 14.9531 12.4671 14.9789 12.8028C14.9883 12.9409 14.9836 13.079 15 13.2171C15 13.4075 15 13.598 15 13.7885Z"
            fill="white"
          />
        </Svg>
      );

    case "itemsReturned":
      return (
        <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
          <Path
            d="M10 2c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zM7.832 13.432L4.96 10.56a.797.797 0 111.128-1.128L8.4 11.736l5.504-5.504a.797.797 0 111.128 1.128L8.96 13.432a.797.797 0 01-1.128 0z"
            fill="#27AE60"
          />
        </Svg>
      );

    default:
      return <></>;
  }
}

export default OrderReturnStatus;
